module.exports = __webpack_public_path__ + "static/media/logo_w.fc2b944f.png";